/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import generateRandomImagePlaceholderPath from "lib/generate-random-image-placeholder";
import NextImage from "next/image";

const ContainerDiv = styled.div`
  :hover {
    background-color: ${({ theme }) => theme.themeColors.lightGreen1};
  }
`;

const View = styled.div`
  color: ${({ theme }) => theme.themeColors.orange1};
  align-self: flex-start;
  flex-grow: 1;
  font-size: 1rem;
`;

const CardWrapperButton = styled.button`
  background-color: white;
  border: none;
  display: flex;
  text-align: left;
  align-items: center;
  padding: 1rem;
  border-radius: 11px;
  width: 100%;

  :hover {
    background-color: ${({ theme }) => theme.themeColors.lightGreen1};
  }
  :focus {
    outline: 0;
  }

  :focus-only {
    outline: 2px solid #0070f3;
  }
`;

const CardWrapperDiv = styled.div`
  background-color: white;
  border: none;
  display: flex;
  text-align: left;
  align-items: center;
  padding: 0;
`;

const ImageWrapper = styled.div`
  margin-right: 16px;
  max-width: ${({ imageWidth }) => imageWidth}px;
  max-height: ${({ imageHeight }) => imageHeight}px;
  flex-grow: 1;
`;

const Image = styled(NextImage)`
  border-radius: ${({ isCircle }) => (isCircle ? "100%" : "12px")};
`;

const TextWrapper = styled.div`
  display: table;
  table-layout: fixed;
  width: 190px;
  flex-grow: 26;
`;

const TextSubWrapper = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

const TextClaimWrapper = styled.div`
  font-size:small;
  display: table-header-group;
  color: ${({ theme }) => theme.themeColors.success};
`

const LightParagraph = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  line-height: 14px;
  font-weight: 400;
  margin: 0;
  font-size: 12px;
`;

const LargeFont = styled.h4`
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
`;

const SmallBusinessCard = ({
  onClick,
  vendorBusiness,
  imageWidth,
  imageHeight,
  isCircle,
  hasViewButton,
  showClaimStatus,
}) => {
  if (!vendorBusiness) {
    return (
      <CardWrapperDiv>
        <ImageWrapper />
        <TextWrapper>
          <TextSubWrapper>
            <LargeFont />
            <LightParagraph />
          </TextSubWrapper>
        </TextWrapper>
      </CardWrapperDiv>
    );
  }

  const imageUrl = vendorBusiness?.attributes.logo?.sizes?.small?.url;
  const formattedAddress = vendorBusiness?.attributes?.formattedAddress;
  const vuid = vendorBusiness?.attributes?.vendorUserId;
  return (
    <ContainerDiv>
      {onClick ? (
        <CardWrapperButton type="button" onClick={onClick}>
          <ImageWrapper imageHeight={imageHeight} imageWidth={imageWidth}>
            <Image
              isCircle={isCircle}
              height={imageHeight}
              width={imageWidth}
              src={
                imageUrl ||
                generateRandomImagePlaceholderPath(
                  vendorBusiness.id,
                  vendorBusiness.include?.vendorServices?.data
                )
              }
            />
          </ImageWrapper>
          <TextWrapper>
            <TextSubWrapper>
              <LargeFont>{vendorBusiness.attributes.businessName}</LargeFont>
              <LightParagraph>{formattedAddress}</LightParagraph>
            </TextSubWrapper>
          </TextWrapper>
          {hasViewButton && <View>View</View>}
        </CardWrapperButton>
      ) : (
        <CardWrapperDiv>
          <ImageWrapper imageHeight={imageHeight} imageWidth={imageWidth}>
            <Image
              height={imageHeight}
              width={imageWidth}
              src={generateRandomImagePlaceholderPath(
                vendorBusiness.id,
                vendorBusiness.include?.vendorServices?.data
              )}
            />
          </ImageWrapper>
          <TextWrapper>
            <TextClaimWrapper>{vuid && showClaimStatus ? "Claimed" : null}</TextClaimWrapper>
            <TextSubWrapper>
              <LargeFont>{vendorBusiness.attributes.businessName}</LargeFont>
              <LightParagraph>{formattedAddress}</LightParagraph>
            </TextSubWrapper>
          </TextWrapper>
        </CardWrapperDiv>
      )}
    </ContainerDiv>
  );
};

SmallBusinessCard.propTypes = {
  onClick: PropTypes.func,
  vendorBusiness: PropTypes.object,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  isCircle: PropTypes.bool,
  hasViewButton: PropTypes.bool,
  showClaimStatus: PropTypes.bool,
};

SmallBusinessCard.defaultProps = {
  imageWidth: "84",
  imageHeight: "63",
  isCircle: false,
  hasViewButton: false,
  onClick: undefined,
  vendorBusiness: null,
  showClaimStatus: false,
};

export default SmallBusinessCard;
